"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CountryFlag = _interopRequireDefault(require("./CountryFlag"));

var _strings = require("../utils/strings");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function EntityIllustration(props) {
  var getImageSrcFromProps = (0, _react.useCallback)(function () {
    return (0, _strings.isEmpty)(props.base64) ? props.imageUrl : "data:image/jpeg;base64,".concat(props.base64);
  }, [props.base64, props.imageUrl]);

  var _React$useState = _react.default.useState(getImageSrcFromProps()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      imageUrl = _React$useState2[0],
      setImageUrl = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      onError = _React$useState4[0],
      setOnError = _React$useState4[1];

  _react.default.useEffect(function () {
    setOnError(false);
    setImageUrl(getImageSrcFromProps());
  }, [getImageSrcFromProps, props.base64, props.imageUrl]);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "entity-illustration".concat(props.small ? ' small' : ''),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "illustration",
      children: imageUrl && !onError ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: imageUrl,
        alt: props.name,
        onError: function onError() {
          return setOnError(true);
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: props.name[0]
      })
    }), props.country && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
      tooltipLabel: props.tooltipLabel,
      country: props.country,
      size: props.small ? 14 : 17
    })]
  });
}

EntityIllustration.defaultProps = {
  small: false,
  name: '.'
};
EntityIllustration.propTypes = {
  country: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  base64: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  small: _propTypes.default.bool,
  tooltipLabel: _propTypes.default.string
};
var _default = EntityIllustration;
exports.default = _default;
//# sourceMappingURL=EntityIllustration.js.map